import React from 'react';
import { Button } from 'js/components/common/Button';
import { Icon } from 'js/components/common/Icon';
import { usePortletDispatch, usePortletTranslations } from 'js/components/system/Portlet';
import { resetFiltersAction } from './actions';
import style from './index.scss';

export const Reset = () => {
    const t = usePortletTranslations();
    const dispatch = usePortletDispatch();

    return (
        <Button
            variant="rounded"
            color="negative"
            view="secondary"
            size="medium"
            onClick={() => dispatch(resetFiltersAction())}
            className={`${style.btn} ${style.clear}`}>
            <Icon
                type="filterClear"
                className={style.icon}
            />
            {t('clearFilters')}
        </Button>
    );
};

export default Reset;
